import { combineReducers } from "@reduxjs/toolkit";
import SignOutAndClear from "../symbols/signOutAndClearAllReducers";
import login from "./login";
import error from "./error";
import pendingOrders from "./pendingOrders";
import orderDetails from "./orderDetails";
import dispatchOrders from "./dispatchedOrders";
import queuedOrders from "./queuedOrders";
import deliveryAccept from "./deliveryAccept";
import packages from "./packages";
import shopList from "./shoplist";
import shopDetails from "./shopDetails";
import accountDetails from "./accountDetails";
import VerticalSymbolsReducer from "./verticals";
import VerticalDetailsSymbolsReducer from "./verticalDetails";
import CategorySymbolsReducer from "./categories";
import CategoryDetailsSymbolsReducer from "./categoryDetails";
import SubcategoryDetailsSymbolsReducer from "./subcategoryDetails";
import SubcategoryProductsSymbolsReducer from "./subcategoryProducts";
import SubcategorySymbolsReducer from "./subcategories";
import CollectionSymbolsReducer from "./collections";
import BannerSymbolsReducer from "./banners";
import BannerDetailsSymbolsReducer from "./bannerDetails";
import CollectionDetailsSymbolsReducer from "./collectionDetails";
import CriteriaSymbolsReducer from "./criterias";
import orderChangeQuantity from "./orderChangeQuantity";
import deliveryHasCancellation from "./deliveryHasCancellation";
import acknowledgeCancellation from "./acknowledgeCancellation";
import resetQuantity from "./resetQuantity";
import rejectOrder from "./rejectOrder";
import PromotionCodesSymbolsReducer from "./promotionCodes";
import CreatePromotionCodesSymbolsReducer from "./createPromotionCode";
import ReferralCodesSymbolsReducer from "./referralCodes";
import OrdersReducer from "./orders";
import UpcEditorReducer from "./upcEditor";
import GetMerchantInfoReducer from "./getMerchantInfo";
import GetDriverInfoReducer from "./getDriverInfo";
import GetShopNamesReducer from "./getShopNames";
import OrderSortFilterReducer from "./orderSortFilter";
import OrderInterval from "./orderInterval";
import PushNotificationReducer from "./pushNotifications";
import CreatePushNotificationReducer from "./createPushNotification";
import failedOrders from "./failedOrders";
import resolveFailedDelivery from "./resolveFailedDelivery";
import storage from "redux-persist/lib/storage";
import shopInvoices from "./shopInvoices";
import unbindedSubcategories from "./unbindedSubcategories";
import bindSubcategories from "./bindSubcategories";
import unbindSubcategories from "./unbindSubcategories";
import getInvoiceMerchants from "./getInvoiceMerchants";
import getInvoiceShops from "./getInvoiceShops";
import getAdminInvoices from "./getAdminInvoices";
import checkNewOrdersPending from "./checkNewOrdersPending";
import checkNewOrdersQueued from "./checkNewOrdersQueued";
import checkNewOrdersFailed from "./checkNewOrdersFailed";
import checkNewOrdersArchived from "./checkNewOrdersArchived";
import notificationOrderInterval from "./notificationOrderInterval";
import collectionOrderDetail from "./collectionOrderDetail";
import collectionOrderList from "./collectionOrderList";
import checkNewCollectOrders from "./checkNewCollectOrders";
import collectOrdersFilters from "./collectOrdersFilters";
import getCollectionTime from "./getCollectionTime";
import getShopCities from "./getShopCities";
import getShopRegions from "./getShopRegions";
import addShop from "./addShop";
import forgotPassword from "./sendForgotPasswordEmail";
import resetPassword from "./resetPassword";
import getMerchantInvoices from "./getMerchantInvoices";
import credits from "./credits";

const appReducer = combineReducers({
  login,
  error,
  pendingOrders,
  orderDetails,
  queuedOrders,
  dispatchOrders,
  deliveryAccept,
  packages,
  shopList,
  shopDetails,
  accountDetails,
  VerticalSymbolsReducer,
  CategorySymbolsReducer,
  VerticalDetailsSymbolsReducer,
  CategoryDetailsSymbolsReducer,
  SubcategoryDetailsSymbolsReducer,
  SubcategoryProductsSymbolsReducer,
  SubcategorySymbolsReducer,
  CollectionSymbolsReducer,
  BannerSymbolsReducer,
  BannerDetailsSymbolsReducer,
  CollectionDetailsSymbolsReducer,
  CriteriaSymbolsReducer,
  deliveryHasCancellation,
  acknowledgeCancellation,
  orderChangeQuantity,
  resetQuantity,
  rejectOrder,
  PromotionCodesSymbolsReducer,
  CreatePromotionCodesSymbolsReducer,
  ReferralCodesSymbolsReducer,
  OrdersReducer,
  UpcEditorReducer,
  GetMerchantInfoReducer,
  GetDriverInfoReducer,
  GetShopNamesReducer,
  OrderSortFilterReducer,
  OrderInterval,
  PushNotificationReducer,
  CreatePushNotificationReducer,
  failedOrders,
  resolveFailedDelivery,
  shopInvoices,
  unbindedSubcategories,
  bindSubcategories,
  unbindSubcategories,
  getInvoiceMerchants,
  getInvoiceShops,
  getAdminInvoices,
  getMerchantInvoices,
  checkNewOrdersPending,
  checkNewOrdersQueued,
  checkNewOrdersFailed,
  checkNewOrdersArchived,
  checkNewCollectOrders,
  notificationOrderInterval,
  collectionOrderDetail,
  collectionOrderList,
  collectOrdersFilters,
  getCollectionTime,
  getShopCities,
  getShopRegions,
  addShop,
  forgotPassword,
  resetPassword,
  credits
});

const rootReducer = (state: any, action: any) => {
  if (action.type === SignOutAndClear.SIGN_OUT_AND_CLEAR_ALL_REDUCERS) {
    storage.removeItem("persist:root");
    return appReducer(undefined, action);
  } else {
    return appReducer(state, action);
  }
};

export default rootReducer;

export type RootState = ReturnType<typeof appReducer>;
